export default [
  {
    name: 'firstName',
    label: {
      cs: 'Jméno',
      en: 'First name',
    },
    main: true,
    input: 'input',
    type: 'string',
    minLength: 2,
    maxLength: 32,
    required: true,
  },
  {
    name: 'lastName',
    label: {
      cs: 'Příjmení',
      en: 'Last name',
    },
    main: true,
    input: 'input',
    type: 'string',
    minLength: 2,
    maxLength: 32,
    required: true,
  },
  {
    name: 'position.cs',
    label: {
      cs: 'Pozice [CS]',
      en: 'Position [CS]',
    },
    input: 'input',
    type: 'string',
    minLength: 2,
    maxLength: 32,
    required: true,
  },
  {
    name: 'position.en',
    label: {
      cs: 'Pozice [EN]',
      en: 'Position [EN]',
    },
    input: 'input',
    type: 'string',
    minLength: 2,
    maxLength: 32,
    required: true,
  },
  {
    name: 'email',
    label: {
      cs: 'E-mail',
      en: 'E-mail',
    },
    input: 'input',
    note: 'Optional',
    type: 'string',
    minLength: 2,
    maxLength: 128,
  },
  {
    name: 'phone',
    label: {
      cs: 'Telefon',
      en: 'Phone',
    },
    input: 'input',
    placeholder: '+420 123 456 789',
    note: 'Optional',
    type: 'string',
    minLength: 2,
    maxLength: 16,
  },
  {
    name: 'code',
    label: {
      cs: 'Kód',
      en: 'Code',
    },
    input: 'input',
    note: '/img/contact/{code}',
    link: './#/admin/upload/photo',
    type: 'string',
    minLength: 2,
    maxLength: 32,
    required: true,
  },
  {
    name: 'photo',
    label: {
      cs: 'Fotografie',
      en: 'Photo',
    },
    input: 'radio-group',
    elements: [
      { value: true, label: 'True' },
      { value: false, label: 'False' },
    ],
    type: 'boolean',
    required: true,
  },
];
